;(function ($) {
  $(function () {
    const servicesModal = $('.js-services-modal')
    const serviceModalIndicator = $('.js-read-more')
    const closeServiceModalIndicator = $('.js-close-modal')

    if (!servicesModal.length) {
      return
    }

    serviceModalIndicator.on('click', function (e) {
      e.preventDefault()

      var title = $(this).data('title')
      var text = $(this).data('text')
      var button_url = $(this).data('button-url')
      var button_title = $(this).data('button-title')
      var image = $(this).data('image')
      var data_modal_video =  $(this).data('modal-video');
      var data_with_video = $(this).data('with-video');
      var data_yt = $(this).data('yt');
      var data_video = $(this).data('video');

      console.log(data_modal_video);
      console.log(data_with_video);
      console.log(data_yt);
      console.log(data_video);


      if (title) {
        servicesModal.find('h4').text(title).show()
      } else {
        servicesModal.find('h4').hide();
      }

      if (image && !data_modal_video) {
        servicesModal.find('.modal-image').attr('src', image).show()
      } else {
        servicesModal.find('.modal-image').hide()
      }

      if (data_modal_video) {
          servicesModal.addClass('with-video');
          servicesModal.find('.services-modal__iframe-wrapper').show();
          var iframeWrapper = servicesModal.find('.services-modal__iframe-wrapper');
          var iframe = iframeWrapper.find('iframe');
          var videoElement = iframeWrapper.find('video');
      
          if (data_with_video && data_video) {
              iframe.hide();
              videoElement.show().find('source').attr('src', data_video);
              videoElement[0].load();
          } else if (!data_with_video && data_yt) {
              videoElement.hide();
              iframe.show().attr('src', 'https://www.youtube.com/embed/' + data_yt);
          } else {
              iframeWrapper.hide();
          }
      } else {
          servicesModal.removeClass('with-video');
          servicesModal.find('.services-modal__iframe-wrapper').hide();
      }
    

      if (text) {
        servicesModal.find('p').text(text).show()
      } else {
        servicesModal.find('p').hide()
      }

      if (button_url && button_title) {
        var button = servicesModal.find('a')
        button.attr('href', button_url).text(button_title).show()
      } else {
        servicesModal.find('a').hide()
      }

      servicesModal.addClass('is-visible')
    })

    closeServiceModalIndicator.on('click', function (e) {
      e.preventDefault()
      servicesModal.removeClass('is-visible')
    })
  })
})(jQuery)
